import { paperClasses, styled } from '@mui/material';
import { PopoverArrow } from '@procureai/ui-mui';

export const PopoverArrowStyled = styled(PopoverArrow)(({ theme }) => ({
  [`& .${paperClasses.root}`]: {
    marginTop: theme.spacing(2),
  },
}));
